function dropCollect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
  };
}

const dropTargetFactory = (actionCallback) => {
  return {
    canDrop() {
      //Can always drop on these babies (the breadcrumbs, those are the babies)
      return true;
    },

    drop(props, monitor) {
      if (monitor.didDrop()) {
        return;
      }
      const monitorItem = monitor.getItem();
      const objectToMoveId = monitorItem.item._id;

      let objectIdsToMove = [objectToMoveId];

      if (monitorItem.selectedItemIds && monitorItem.selectedItemIds.length) {
        objectIdsToMove = monitorItem.selectedItemIds;
      }

      actionCallback(objectIdsToMove, props);
    },
  };
};

export { dropTargetFactory, dropCollect };
